var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '../../../GSAPAnimations/Typography';
import './index.scss';
var BlockContent = function (_a) {
    var title = _a.title, classes = _a.classes, children = _a.children, reference = _a.reference, animate = _a.animate;
    return (_jsxs("div", __assign({ className: "block__content-container" }, { children: [title && (_jsx(Typography, { title: title, classes: classes, reference: reference }, void 0)), children] }), void 0));
};
export default BlockContent;
